import {ReactNode, useEffect, useState} from "react"
import {paymentArrangementAPI} from "@indebted/api/paymentArrangementAPI"
import {useNavigate} from "react-router-dom"
import {LoadingPage} from "@indebted/components/Loading"
import {ErrorPage} from "@indebted/components/Error"

import {ManagePageType} from "../types"
import {nextPage} from "../Navigator"
import {usePaymentArrangementId} from "../usePaymentArrangementId"

import {ManagePaymentArrangement} from "./ManagePaymentArrangement"

const ManagePaymentArrangementPage = () => {
	const paymentArrangementID = usePaymentArrangementId()
	const [Component, setComponent] = useState<ReactNode>(<LoadingPage />)
	const navigate = useNavigate()

	useEffect(() => {
		paymentArrangementAPI
			.getManagePage({paymentArrangementID})
			.then((result: ManagePageType) => {
				if (result?.Next) {
					navigate(nextPage(result.Next, paymentArrangementID))
				} else {
					setComponent(
						<ManagePaymentArrangement
							{...result}
							PaymentArrangementID={paymentArrangementID}
							setComponent={setComponent}
						/>,
					)
				}
			})
			.catch((error) => {
				setComponent(<ErrorPage error={error} />)
			})
	}, [paymentArrangementID, navigate])

	return Component
}

export {ManagePaymentArrangementPage}
